exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1Ojeg{position:absolute;bottom:-50px;right:0;border-radius:20px;background-color:#e4002b;color:#fff;padding:5px 14px;font-size:20px;font-weight:700;cursor:pointer}", ""]);

// exports
exports.locals = {
	"modalVideoLlamadaHide": "_1Ojeg"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Telemedicina/ModalVideoLlamada/HideModalVideoLlamada/HideModalVideoLlamada.css
// module id = 1192
// module chunks = 0 1 2